import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const ITHardwareDeploymentServices = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="min-h-screen bg-blue-950 text-black py-16 px-6 sm:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Hero */}
        <div data-aos="fade-up" className="text-center">
          <h2 className="text-4xl font-bold font-poppins text-sky-400">
            IT Hardware Deployment Services
          </h2>
          <p className="text-lg text-white mt-4 font-inter">
            Tailored hardware and support solutions to empower your workforce.
          </p>
        </div>

        {/* Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-aos="fade-right">
          <img
            src="/servicepages/procurement.jpg"
            alt="Workstation Setup"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
          <div className="space-y-4">
            <ul className="list-disc list-inside text-white text-base font-poppins space-y-1">
              <li>Procurement of desktops, laptops, servers, and IT peripherals</li>
              <li>Provide solutions based on business requirements</li>
              <li>Partnerships with trusted OEMs for quality assurance</li>
              <li>Expert consultation on configuration and compatibility</li>
              <li>Post-sales support and warranty handling</li>
              <li>AMC (Annual Maintenance Contracts) available</li>
            </ul>
            
          </div>
        </div>

        {/* Plans */}
        <div className="bg-gray-400 p-8 rounded-lg shadow" data-aos="fade-up">
          <h3 className="text-2xl font-semibold font-poppins text-center mb-6 text-blue-950">
            Support & Warranty Plans
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { tier: "Basic", info: "1-year warranty + remote support" },
              { tier: "Standard", info: "2-year warranty + remote & on-site support" },
              { tier: "Premium", info: "3-year warranty + priority support & replacements" }
            ].map((plan, i) => (
              <div key={i} className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
                <h4 className="text-xl font-semibold text-blue-500">{plan.tier}</h4>
                <p className="text-black mb-4">{plan.info}</p>
                <a
                  href="/contact"
                  className="bg-blue-950 text-white px-4 py-2 rounded-md font-medium hover:bg-blue-800 transition inline-block"
                >
                  Enquire Now
                </a>
              </div>
            ))}
          </div>
        </div>

       {/* CTA */}
        <div className="text-center">
          <a
            href="/contact"
            className="inline-block bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
          >
            Talk to Our Experts
          </a>
        </div>
        
      </div>
    </section>
  );
};

export default ITHardwareDeploymentServices;
